/**
 * Return the URL + params or null if no params
 * @param {string?=} baseUrl
 * @param {string|number?=} params
 */
export const urlBuilder = (baseUrl, params) => {
  if (baseUrl && params) {
    if (baseUrl.includes('?')) {
      return baseUrl + '&' + params;
    }

    if (baseUrl.includes('=')) {
      return '&' + baseUrl + params;
    }

    return baseUrl + '?' + params;
  }

  return null;
};

/**
 * Scroll to the top. Element is the main parent on the Default layout and identified by ID
 */
export const scrollToTop = () => {
  document
    .getElementById('main-content-layout-parent')
    ?.scrollTo({ top: 0, behavior: 'smooth' });
};

// Define the opacity for the heatmap colors
export const opacityScaling = (
  /** @type {number} */ currentValue,
  /** @type {{ max: number; min: number; }} */ metrics,
  maxOpacity = 0.7,
  minOpacity = 0.1
) => {
  const opacity =
    minOpacity +
    ((currentValue - metrics.min) * (maxOpacity - minOpacity)) /
      (metrics.max - metrics.min);

  if (opacity <= 0.175) return 0.1;
  if (opacity > 0.175 && opacity <= 0.35) return 0.3;
  if (opacity > 0.35 && opacity <= 0.525) return 0.5;
  if (opacity > 0.525) return 0.7;
};

/**
 * Extract Currency Symbol from the localeString
 * @param {string} locale
 * @param {string} currency
 * @returns
 */
export const getCurrencySymbol = (locale = 'en-US', currency = 'USD') =>
  (0)
    .toLocaleString(locale, {
      style: 'currency',
      currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })
    .replace(/\d/g, '')
    .trim();

export const splitQueryString = (/** @type {string} */ value) => {
  if (value && typeof value === 'string' && value.indexOf(',') > -1) {
    return value.split(',');
  }
  return value;
};

/**
 * @param {string | undefined} shopifyUrl
 */
export function getStoreNameFromShopifyUrl(shopifyUrl) {
  if (!!!shopifyUrl) return '';
  return shopifyUrl
    .replace('.myshopify.com', '')
    .replace('https://', '')
    .replace('http://', '')
    .replaceAll('-', ' ')
    .toLowerCase();
}

/**
 * Create blob file and download to user browser
 * @param {Blob} blob
 * @param {string} name
 */
export function downloadBlob(blob, name = 'export.csv') {
  const blobUrl = URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.href = blobUrl;
  link.download = name;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
// export const generateShopifyUrlFromStoreName = (
//   /** @type {string} */ storeName
// ) => {
//   if (!!!storeName) return;

//   return storeName.replaceAll(' ', '-') + '.myshopify.com';
// };

export const greetingMessage = () => {
  const currentHour = new Date().getHours();
  // after 4:00AM and before 12:00PM
  if (currentHour >= 4 && currentHour < 12) return 'Good morning';
  // after 12:00PM and before 6:00pm
  if (currentHour >= 12 && currentHour <= 17) return 'Good afternoon';
  // after 5:59pm or before 4:00AM (to accommodate night owls)
  if (currentHour > 17 || currentHour < 4) return 'Good evening';
};

export function mapOrder(array, order, property) {
  let ordered = [],
    unordered = [];

  // Iterate over each item in the supplied array of objects, separating ordered and unordered objects into their own arrays.
  array.forEach((item) => {
    if (order.indexOf(item[property]) === -1) {
      unordered.push(item);
    } else {
      ordered.push(item);
    }
  });

  // Sort the ordered array.
  ordered.sort((a, b) => {
    a = a[property];

    b = b[property];

    if (order.indexOf(a) < order.indexOf(b)) {
      return -1;
    } else {
      return 1;
    }
  });

  // Sort the unordered array.
  unordered.sort((a, b) => {
    a = a[property];
    b = b[property];

    if (a < b) {
      return -1;
    } else if (a > b) {
      return 1;
    } else {
      return 0;
    }
  });

  // Append the sorted, non-ordered array to the sorted, ordered array.
  ordered.push(...unordered);

  return ordered;
}
